import { HttpClient } from '@angular/common/http';
import { TranslateHttpLoader } from '@ngx-translate/http-loader';

import { environment } from '../../environments/environment';

export function createTranslateLoaderFromApi(http: HttpClient) {
  const params = `${environment.translationDevMode ? '?force=true' : ''}`;
  const apiUrl = environment?.i18nUrl || `/translate/app/ga/`;
  return new TranslateHttpLoader(http, `${apiUrl}`, params);
}
